import { MetadataOptionsQuestion } from '../../../types';
import { QuestionInterface } from '../../../types/oldWebForms';
import { reBuildQuestion } from '../reBuildQuestion';
import { normalizeMeterConfigurations } from './meterConfigurationsUtils';

/**
 * Handles initial meter selection when enabling "Update asset data" checkbox.
 * Creates the first meter configuration with the selected meter or location.
 */
export const buildQuestionsOnMeterChange = (
  questionId: string,
  tableId: string | undefined,
  questions: QuestionInterface[],
  value: string,
) => {
  const questionIdsToDeleteAssociatedMetadata: string[] = [];

  const updatedQuestions = reBuildQuestion(
    (question: MetadataOptionsQuestion) => {
      const configs = normalizeMeterConfigurations(question);
      configs.forEach((cfg) =>
        questionIdsToDeleteAssociatedMetadata.push(...(cfg.associatedQuestions ?? [])),
      );

      if (value === '-1') {
        delete question.meterConfigurations;
        delete question.meterId;
        delete question.updateData;
        delete question.associatedQuestions;
        return question;
      }

      if (value === 'nestable_location') {
        question.meterConfigurations = [{ meterId: '', associatedQuestions: [], isLocation: true }];
      } else {
        question.meterConfigurations = [{ meterId: value, associatedQuestions: [] }];
      }

      delete question.meterId;
      delete question.associatedQuestions;
      delete question.updateData;
      return question;
    },
    questionId,
    tableId,
  )(questions);

  return { updatedQuestions, questionIdsToDeleteAssociatedMetadata };
};
